import {IOfferFromJSON} from '../../../../types';
import {Price} from '@vfde-brix/core';
import {
    OFFER_CARD_PRICE_DETAILS_TOTAL_DISCOUNT,
    OFFER_CARD_PRICE_DETAILS_TOTAL_DISCOUNT_LABEL,
    OFFER_CARD_PRICE_DETAILS_TOTAL_ONETIME_DISCOUNT,
    OFFER_CARD_PRICE_DETAILS_TOTAL_ONETIME_DISCOUNT_LABEL,
} from 'Container/OfferDisplay/constant';

/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * FIND STRUCTURE OF PRICE DETAILS IN readme.md
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */

const renderTotalDiscountMonthly = (element: HTMLElement, offer: IOfferFromJSON) => {

    // monthly total discount (label)
    const totalDiscountLabelDIV: HTMLElement = <HTMLElement> element.getElementsByClassName(OFFER_CARD_PRICE_DETAILS_TOTAL_DISCOUNT_LABEL)[0];
    if ('' !== offer.Total_Discount_Label ) {
        totalDiscountLabelDIV.innerHTML = offer.Total_Discount_Label;
    } else {
        totalDiscountLabelDIV.innerHTML = '&nbsp;';
    }

    // monthly total discount
    const totalDiscountDIV: HTMLElement = <HTMLElement> element.getElementsByClassName(OFFER_CARD_PRICE_DETAILS_TOTAL_DISCOUNT)[0];
    if ('' !== offer.Total_Discount) {
        const totalDiscount = Price.fromString(offer.Total_Discount);
        totalDiscountDIV.innerHTML = totalDiscount.toString() + ' &euro;';
    } else {
        totalDiscountDIV.innerHTML = '&nbsp;';
    }

};

const renderTotalDiscountOnetime = (element: HTMLElement, offer: IOfferFromJSON) => {

    // onetime total discount (label)
    const totalOnetimeDiscountLabelDIV: HTMLElement = <HTMLElement>element.getElementsByClassName(OFFER_CARD_PRICE_DETAILS_TOTAL_ONETIME_DISCOUNT_LABEL)[0];
    if ('' !== offer.Discount_Onetime_Label) {
        totalOnetimeDiscountLabelDIV.innerHTML = offer.Discount_Onetime_Label;
    } else {
        totalOnetimeDiscountLabelDIV.innerHTML = '&nbsp;';
    }

    // onetime total discount
    const totalOnetimeDiscountDIV: HTMLElement = <HTMLElement>element.getElementsByClassName(OFFER_CARD_PRICE_DETAILS_TOTAL_ONETIME_DISCOUNT)[0];
    if ('' !== offer.Discount_Onetime) {
        const onetimeDiscount = Price.fromString(offer.Discount_Onetime);
        totalOnetimeDiscountDIV.innerHTML = onetimeDiscount.toString() + ' &euro;';
    } else {
        totalOnetimeDiscountDIV.innerHTML = '&nbsp;';
    }

};

/**
 * renders the multi divider dynamically
 * @param element
 * @param offer
 */
export const renderTotalDiscounts = (element: HTMLElement, offer: IOfferFromJSON) => {

    /**
     * The green line between basket summary and details
     * @param offer
     */
    renderTotalDiscountMonthly(element, offer);
    renderTotalDiscountOnetime(element, offer);

};
